import { parseDate } from 'global/Utility/TSFunctions';
import { Ibcbs_config_attribute_extended } from 'model/CRM.type';
import { IGLWindow } from 'model/GroupLibraryWindow';
import {
    EBenefitStatus as FAM_EBenefitStatus,
    EGroupConfigurationStatus as FAM_EGroupConfigurationStatus,
    EProduct as FAM_EProduct,
    IAccountsReceivable as FAM_IAccountsReceivable,
    IBenefit as FAM_IBenefit,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IFlexibleField as FAM_IFlexibleField,
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    IGroupNumber as FAM_IGroupNumber,
    INonStandard as FAM_INonStandard,
    INonStandardTemplate as FAM_INonStandardTemplate,
    IPlan as FAM_IPlan,
    IStopLoss as FAM_IStopLoss
} from '../../model/FlexibleAttributeModel';
import { EHideReason } from './EHideReason';
import { IFieldReference } from './IFieldReference';
import { IVisibilityScope } from './IVisibilityScope.type';
import { ParentVisibilityGraphProcessor } from './ParentVisibilityGraph';

// TODO needs to be refactored to use cache and also should follow FieldsToLookupByMasterAttributeId pattern or use that as input
// TODO also needs to only work with changed fields if all calls allow for it, right now looks like it return everything going invisible
export function ApplyVisibilityFields(config: FAM_IGroupConfigurationConfig, fields: FAM_IFlexibleField[], scope: IVisibilityScope) {

    // const { configToFieldIx, masterConfigToFieldIx } = fieldsMap(config, fields);
    const fieldMapByConfigRefId = new Map<string, IFieldReference>();
    const hiddenFieldMapByConfigRefId = new Map<string, IFieldReference>();

    fields.forEach((eField, eachFieldIndex) => {

        const attribute = config.cache.map_bcbs_config_attribute[eField.configRef.id] as Ibcbs_config_attribute_extended;

        if (!attribute) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-attribute', eField.configRef.id)
            return;
        }

        const masterAttribute = config.cache.map_bcbs_config_masterattribute[attribute._bcbs_config_masterattributeid_value!];
        if (!masterAttribute) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-master-attribute', attribute._bcbs_config_masterattributeid_value)
            return;
        }

        const eFieldReference = {
            index: eachFieldIndex,
            field: eField,
            attribute: attribute,
            masterAttribute: masterAttribute,
        };

        // map all the fields by their attribute id so we can get the value
        fieldMapByConfigRefId.set(eField.configRef.id, eFieldReference);

        const attributeVisibility = attribute.visibility;

        if (!attributeVisibility) {
            console.warn("[visi] GlobalVisibility.ApplyVisibilityFields", 'missing-visibility-attributes', eField.configRef.id)
            return;
        }

        // if (attribute.bcbs_config_attributeid === '5d1b4bb4-720f-ee11-8f6d-000d3a305861'){
        //     debugger;
        // }

        const attribute_operative_effectiveDate = attributeVisibility.effectiveDate;
        const attribute_operative_ExpirationDate = attributeVisibility.expirationDate;
        const attribute_effective_effectiveDate = attributeVisibility.effective_effectiveDate
        const attribute_effective_expirationDate = attributeVisibility.effective_expirationDate;

        let visibility = EHideReason.Visible;

        // Effective Effective Date
        if (attribute_effective_effectiveDate > 0 && scope.effectiveDate > 0 && attribute_effective_effectiveDate > scope.effectiveDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else if (attribute_operative_effectiveDate > 0 && scope.operativeDate > 0 && attribute_operative_effectiveDate > scope.operativeDate)
            visibility = visibility | EHideReason.EffectiveDate;
        else
            visibility = visibility & ~(EHideReason.EffectiveDate);

        // Effective Expiration Date
        if (attribute_effective_expirationDate > 0 && scope.effectiveDate > 0 && attribute_effective_expirationDate < scope.effectiveDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else if (attribute_operative_ExpirationDate > 0 && scope.operativeDate > 0 && attribute_operative_ExpirationDate < scope.operativeDate)
            visibility = visibility | EHideReason.ExpirationDate;
        else
            visibility = visibility & ~(EHideReason.ExpirationDate);

        // // if on the config, they have picked Effective Date(808900001) as the rule
        // if (attribute.bcbs_enablebasedoncode === IXrmOptions.bcbs_config_attribute.bcbs_enablebasedoncode['Effective Date(808900001)'].value) {
        // } else {
        //     // attribute.bcbs_enablebasedoncode === null 
        //     // attribute.bcbs_enablebasedoncode === undefined 
        //     // attribute.bcbs_enablebasedoncode === IXrmOptions.bcbs_config_attribute.bcbs_enablebasedoncode['Created On(808900000)'].value 
        //     // Effective Date
        //     // Expiration Date
        // }

        // Funding Type
        if (scope.fundingType !== null)
            if (!attributeVisibility?.fundingType?.[scope.fundingType])
                visibility = visibility | EHideReason.fundingType;
            else
                visibility = visibility & ~(EHideReason.fundingType);

        // Grand Fathered
        // apply only if applicable:
        // for some benefit categories e.x. Vision, if it is set to not enabled grandfather, this check needs to ignore
        if (scope.grandFathered !== null)
            if (!attributeVisibility?.grandFathered?.[scope.grandFathered])
                visibility = visibility | EHideReason.grandFathered;
            else
                visibility = visibility & ~(EHideReason.grandFathered);

        // Erisa
        if (scope.erisa !== null)
            if (!attributeVisibility?.erisa?.[scope.erisa])
                visibility = visibility | EHideReason.erisa;
            else
                visibility = visibility & ~(EHideReason.erisa);

        // lineOfBusiness
        if (scope.lineOfBusiness !== null)
            if (!attributeVisibility?.lineOfBusiness?.[scope.lineOfBusiness])
                visibility = visibility | EHideReason.lineOfBusiness;
            else
                visibility = visibility & ~(EHideReason.lineOfBusiness);

        // Cancellation
        if (attribute.bcbs_iscancellation)
            if (scope.cancelled != null) {
                if (scope.cancelled === true)
                    visibility = visibility & ~(EHideReason.Cancellation);
                else
                    visibility = visibility | EHideReason.Cancellation;
            }


        if (visibility) {
            eField.visibility = visibility;

            // clear values
            eField.values.forEach(eachFieldValue => {
                // console.log('clearing value for hidden field', eField.configRef.id, eachFieldValue.value);
                eachFieldValue.value = null;
            });

            hiddenFieldMapByConfigRefId.set(eField.configRef.id, eFieldReference);
        }
        else {
            delete eField.visibility
        }

    });


    const graphProcessor = new ParentVisibilityGraphProcessor(config, config.cache.parentVisibilityGraph);
    const graphChange = graphProcessor.processVisibilityForContext(fieldMapByConfigRefId);
    graphChange.forEach(eachChange => {
        if (eachChange.newVisibility) {

            const eField = fields[eachChange.index];
            eField.visibility = eachChange.newVisibility;

            // if for any reason it is hidden, remove the values
            eField.values.forEach(eachFieldValue => {
                eachFieldValue.value = null;
            });

            hiddenFieldMapByConfigRefId.set(eField.configRef.id, eachChange);
        }
        else
            delete fields[eachChange.index].visibility;
    });

    return hiddenFieldMapByConfigRefId;
}

/**
 * 
 * @param parentScope context scope that this function will try to build on
 * @param root parent json
 * @param benefit inside a benefit context, otherwise null
 * @param plan inside a plan context, otherwise null
 * @returns 
 */
export function BuildVisibilityScope(
    parentScope: IVisibilityScope | null,
    root: FAM_IGroupConfigurationData,
    benefit: FAM_IBenefit | null | undefined,
    plan: FAM_IPlan | null | undefined,
    groupNumber?: FAM_IGroupNumber | null | undefined,
): IVisibilityScope {

    // created-on on replaced effective-date (data.effectiveDate?.value)
    // it was decided to switch to operativeDate which closely follows created on.
    // instead of created on a place holder called operativeDate was implemented.

    // we start from group configuration and gradually build scope
    const retScope: IVisibilityScope = parentScope
        ? {
            ...parentScope,
            cancelled: false,
        }
        : {
            operativeDate: root?.operativeDate?.value
                ? parseDate(root.operativeDate.value, 'local:yyyy-MM-dd').getTime()
                : 0,
            effectiveDate: root?.effectiveDate?.value
                ? parseDate(root.effectiveDate.value, 'local:yyyy-MM-dd').getTime()
                : 0,
            fundingType: root?.fundingType?.value ?? 0,
            erisa: root?.erisa?.value ?? 0,
            lineOfBusiness: root?.lineOfBusiness?.value ?? 0,
            grandFathered: root?.grandFathered?.value ?? 0,
            product: false,
            cancelled: false,
        };

    // applying too root level
    if (root) {

        // only set cancel if scope is running at for group configuration root level elements
        // https://dev.azure.com/blue-infosys/Group%20Library/_workitems/edit/658885
        if (!benefit && !plan && !groupNumber) {

            if (root?.status?.value === FAM_EGroupConfigurationStatus.Cancelled) {
                retScope.cancelled = true;
            }

            if (root?.status?.value === FAM_EGroupConfigurationStatus['Cancellation in Progress']) {
                retScope.cancelled = true;
            }
        }
    }

    if (plan) {
        retScope.fundingType = plan.fundingType?.value ?? retScope.fundingType;
        retScope.grandFathered = plan.grandFathered?.value ?? retScope.fundingType;
        // retScope.cancelled = plan.status?.value === FAM.EBenefitStatus.Cancelled;
    }

    if (benefit) {
        retScope.fundingType = benefit.fundingType?.value ?? retScope.fundingType;

        if (benefit.grandFathered?.value)
            retScope.grandFathered = benefit.grandFathered?.value;

        if (benefit.product?.value)
            retScope.product = benefit.product?.value === FAM_EProduct.Yes

        if (benefit.status?.value === FAM_EBenefitStatus.Cancelled)
            retScope.cancelled = true;
    }

    if (groupNumber) {
        if (groupNumber.status?.value === FAM_EBenefitStatus.Cancelled)
            retScope.cancelled = true;
    }

    return retScope;
}

export const applyVisibilityGroupConfiguration = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    groupConfiguration: FAM_IGroupConfigurationData
) => {
    const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, groupConfiguration.fields, parentScope);

    groupConfiguration.nonStandards.forEach(eachNonStandard => {
        ApplyVisibilityFields(config, eachNonStandard.fields, parentScope);
    });

    // TODO Review, this was missed, we need to implmenet this
    // applyVisibilityAttributeSets(data, config, gcScope, groupConfiguration.attributeSets, hiddenFieldMapByConfigRefId)

    // TODO Review, this was missed, we need to implmenet this
    // applyVisibilityNonstandards(data, config, gcScope, null, groupConfiguration.nonStandards)

}


export const applyVisibilityPlan = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    plans: FAM_IPlan[],
) => {

    plans.forEach(e => {
        const _scopeVisibility = BuildVisibilityScope(parentScope, data, null, e);

        ApplyVisibilityFields(config, e.fields, _scopeVisibility);

        e.attributeSets?.forEach(e2 => {
            ApplyVisibilityFields(config, e2.fields, _scopeVisibility)
        })
    })
}


export const applyVisibilityBenefit = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    benefits: FAM_IBenefit[],
) => {

    benefits.forEach(eBenefit => {

        const benefitScope = BuildVisibilityScope(
            parentScope,
            data,
            eBenefit,
            null
        );

        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eBenefit.fields, benefitScope);

        applyVisibilityAttributeSets(data, config, benefitScope, eBenefit.attributeSets, hiddenFieldMapByConfigRefId)

        eBenefit.nonStandards.forEach(eNonStandards => {
            // TODO Review, better use the applyVisibilityNonstandard function
            // applyVisibilityNonstandard(data, config, benefitScope, eBenefit, eNonStandards);
            ApplyVisibilityFields(config, eNonStandards.fields, benefitScope)
        })
    });
}

export const applyVisibilityAttributeSets = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    attributeSets: FAM_IFlexibleFieldSet[],
    parentHiddenFieldsByConfigRefId: Map<string, IFieldReference>

) => {

    var i = attributeSets.length;
    while (i-- > 0) {
        const eAttributeSets = attributeSets[i];

        const configAttributes = config.cache.map_bcbs_config_attribute_by_masterAttributeId[eAttributeSets.attributeSetRef.id];

        if (!configAttributes) {
            console.warn("[visi] GlobalVisibility.applyVisibilityAttributeSets", 'missing-attribute-set', eAttributeSets.attributeSetRef.id)
            continue;
        }

        // any hidden ?
        const configAttributesThatAreHidden = configAttributes
            .map(t => parentHiddenFieldsByConfigRefId.get(t.bcbs_config_attributeid!))
            .filter(t => !!t);

        // This technically should almost always yield to a single attribute describing where the attribute is rendered
        if (configAttributesThatAreHidden.length > 0 && configAttributes.length === configAttributesThatAreHidden.length) {
            // eAttributeSets.deactivated = true;
            attributeSets.splice(i, 1);
        }
        else {
            ApplyVisibilityFields(config, eAttributeSets.fields, parentScope)
        }
    }
}

export const applyVisibilityNonstandard = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope | null,
    benefit: FAM_IBenefit | null,
    nonStandard: FAM_INonStandard,
) => {

    const benefitScope = BuildVisibilityScope(
        parentScope,
        data,
        benefit,
        null
    );

    ApplyVisibilityFields(config, nonStandard.fields, benefitScope);
}

export const applyVisibilityNonstandardTemplate = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope | null,
    benefit: FAM_IBenefit | null,
    nonStandardTemplate: FAM_INonStandardTemplate,
) => {

    const benefitScope = BuildVisibilityScope(
        parentScope,
        data,
        null,
        null
    );
    ApplyVisibilityFields(config, nonStandardTemplate.fields, benefitScope);
}

export const applyVisibilityFeesAndPremiums = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    feesAndPremiums: FAM_IFeesAndPremiums[],
) => {

    feesAndPremiums.forEach(eFeesAndPremium => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eFeesAndPremium.fields, parentScope);
        applyVisibilityAttributeSets(data, config, parentScope, eFeesAndPremium.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibilityGroupNumbers = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    groupNumbers: FAM_IGroupNumber[],
) => {

    groupNumbers.forEach(eachGroupNumber => {
        const groupNumberScope = BuildVisibilityScope(
            parentScope,
            data,
            null,
            null,
            eachGroupNumber
        );

        ApplyVisibilityFields(config, eachGroupNumber.fields, groupNumberScope);
    });

}

export const applyVisibilityStopLosses = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    stopLosses: FAM_IStopLoss[],
) => {
    stopLosses.forEach(eStopLoss => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eStopLoss.fields, parentScope);
        applyVisibilityAttributeSets(data, config, parentScope, eStopLoss.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibilityAccountReceivables = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    parentScope: IVisibilityScope,
    accountReceivables: FAM_IAccountsReceivable[],
) => {

    accountReceivables.forEach(eAccountReceivable => {
        const hiddenFieldMapByConfigRefId = ApplyVisibilityFields(config, eAccountReceivable.fields, parentScope);
        applyVisibilityAttributeSets(data, config, parentScope, eAccountReceivable.attributeSets, hiddenFieldMapByConfigRefId)
    });
}

export const applyVisibility = (
    data: FAM_IGroupConfigurationData,
    config: FAM_IGroupConfigurationConfig,
    rules?: 'all' | 'parentVisibility',
    applyTo?: {
        groupConfiguration?: FAM_IGroupConfigurationData;
        benefit?: FAM_IBenefit;
        plan?: FAM_IPlan;
        feesAndPremium?: FAM_IFeesAndPremiums;
        groupNumber?: FAM_IGroupNumber;
        stopLoss?: FAM_IStopLoss;
        accountReceivable?: FAM_IAccountsReceivable;
    }
) => {

    console.log("[visi] GlobalVisibility.applyVisibility")

    if ((window as IGLWindow)?.debugOptions?.noVisibility) {
        console.warn("[visi] GlobalVisibility.applyVisibility", "eject-debug");
        return;
    }

    // Building Global Scope
    // ---------------------------------------------
    const globalScope: IVisibilityScope = BuildVisibilityScope(
        null,
        data,
        null,
        null
    );

    // Group Configuration
    // ---------------------------------------------
    let groupConfiguration: FAM_IGroupConfigurationData | null = data;

    if (applyTo?.groupConfiguration)
        groupConfiguration = applyTo.groupConfiguration;
    else if (applyTo)
        groupConfiguration = null;

    if (groupConfiguration) {
        applyVisibilityGroupConfiguration(data, config, globalScope, groupConfiguration);
    }

    // Plans
    // ---------------------------------------------
    let plans = data.plans;

    if (applyTo?.plan)
        plans = [applyTo.plan];
    else if (applyTo)
        plans = [];

    applyVisibilityPlan(data, config, globalScope, plans);

    // Benefits
    // ---------------------------------------------
    let benefits = data.benefits;

    if (applyTo?.benefit)
        benefits = [applyTo.benefit];
    else if (applyTo)
        benefits = [];

    applyVisibilityBenefit(data, config, globalScope, benefits);

    // Group Structure
    // ---------------------------------------------
    let groupNumbers = data.groupStructure.groupNumbers;

    if (applyTo?.groupNumber)
        groupNumbers = [applyTo?.groupNumber];
    else if (applyTo)
        groupNumbers = [];

    applyVisibilityGroupNumbers(data, config, globalScope, groupNumbers);



    // Fees And Premiums
    // ---------------------------------------------
    let feesAndPremiums = data.feesAndPremiums;

    if (applyTo?.feesAndPremium)
        feesAndPremiums = [applyTo.feesAndPremium];
    else if (applyTo)
        feesAndPremiums = [];

    applyVisibilityFeesAndPremiums(data, config, globalScope, feesAndPremiums);

    // Stop Loss
    // ---------------------------------------------
    let stopLosses = data.stopLoss;

    if (applyTo?.stopLoss)
        stopLosses = [applyTo.stopLoss];
    else if (applyTo)
        stopLosses = [];

    applyVisibilityStopLosses(data, config, globalScope, stopLosses);

    // Accounts Receivables
    // ---------------------------------------------
    let accountReceivables = data.claimsARs;

    if (applyTo?.accountReceivable)
        accountReceivables = [applyTo.accountReceivable];
    else if (applyTo)
        accountReceivables = [];

    applyVisibilityAccountReceivables(data, config, globalScope, accountReceivables);

}


